import type { GenericResponse } from 'commons/modules/generic-response';

import { LOAD_BATCH } from 'config/api.routes';
import services from 'service/axios';
import { handleResponse } from 'utils/responseTransformer';

import { resolveEntityDomain } from './config';

type MovementsUploadParams = {
  brokerageHouseId: string;
  files: File[];
  date: string;
  layoutTypeId: string;
};

type MovementsUploadV2Params = MovementsUploadParams & {
  investmentOfficeId: string;
};

export type MovementsUploadV2Response = GenericResponse<unknown>;

const buildErrorMessage = (responseData: any): string => {
  const message =
    responseData?.message || 'Ocurrió un error al cargar el archivo';
  const traceId = Array.isArray(responseData?.errors)
    ? responseData.errors.find((e: string) => e.startsWith('trace_id:'))
    : undefined;
  return traceId ? `${message} (${traceId})` : message;
};

export const movementsUploadV2 = async ({
  brokerageHouseId,
  files,
  date,
  layoutTypeId,
  investmentOfficeId,
}: MovementsUploadV2Params): Promise<MovementsUploadV2Response> => {
  const formdata = new FormData();
  formdata.append('brokerageHouseId', brokerageHouseId);
  formdata.append('date', date);
  formdata.append('layoutTypeId', layoutTypeId);
  files.forEach((file) => {
    formdata.append('file', file);
  });

  formdata.append(
    'entityDomain',
    resolveEntityDomain(investmentOfficeId, brokerageHouseId),
  );

  try {
    const res = await services.wt_api<unknown>(`${LOAD_BATCH}/upload/file`, {
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      // redirect: 'follow',
      data: formdata,
    });
    const { data, status } = res;
    return handleResponse(data, status, true);
  } catch (error: any) {
    return handleResponse(
      null,
      error?.response?.status,
      false,
      error,
      [],
      buildErrorMessage(error?.response?.data),
    );
  }
};
